import { useAppDispatch, useAppSelector } from '@common/hooks'
import { fetchApplicationRating } from '@redux/slices/applicationRating'
import { useEffect } from 'react'


export default function AppRatingInitialization(): null {
  const dispatch = useAppDispatch()

  const { isLoading, data: appRating } = useAppSelector(store => store.applicationRating)
  const token = useAppSelector(store => store.common.data.config?.token)
  const application = useAppSelector(store => store.application?.data) as IApplication

  useEffect(() => {
    if(typeof window !== 'undefined' && token && !appRating && !isLoading) {
      void dispatch(fetchApplicationRating({
        id: application.id,
        refresh: true,
      }))
    }
  }, [token])

  return null
}
